import React from 'react';
import { Form, Card } from 'react-bootstrap';

const ThemeEditor = ({ theme, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...theme, [field]: value });
  };

  return (
    <Card className="mb-3">
      <Card.Header className='bg-neutral-gray'>
        <h5 className="mb-0">Theme Settings</h5>
      </Card.Header>
      <Card.Body>
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Primary Color</Form.Label>
              <div className="d-flex gap-2">
                <Form.Control
                  type="color"
                  value={theme.primaryColor}
                  onChange={(e) => handleChange('primaryColor', e.target.value)}
                  style={{ width: '60px' }}
                />
                <Form.Control
                  type="text"
                  value={theme.primaryColor}
                  onChange={(e) => handleChange('primaryColor', e.target.value)}
                />
              </div>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Secondary Color</Form.Label>
              <div className="d-flex gap-2">
                <Form.Control
                  type="color"
                  value={theme.secondaryColor}
                  onChange={(e) => handleChange('secondaryColor', e.target.value)}
                  style={{ width: '60px' }}
                />
                <Form.Control
                  type="text"
                  value={theme.secondaryColor}
                  onChange={(e) => handleChange('secondaryColor', e.target.value)}
                />
              </div>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Text Color</Form.Label>
              <div className="d-flex gap-2">
                <Form.Control
                  type="color"
                  value={theme.textColor}
                  onChange={(e) => handleChange('textColor', e.target.value)}
                  style={{ width: '60px' }}
                />
                <Form.Control
                  type="text"
                  value={theme.textColor}
                  onChange={(e) => handleChange('textColor', e.target.value)}
                />
              </div>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Button Hover Color</Form.Label>
              <div className="d-flex gap-2">
                <Form.Control
                  type="color"
                  value={theme.buttonHoverColor}
                  onChange={(e) => handleChange('buttonHoverColor', e.target.value)}
                  style={{ width: '60px' }}
                />
                <Form.Control
                  type="text"
                  value={theme.buttonHoverColor}
                  onChange={(e) => handleChange('buttonHoverColor', e.target.value)}
                />
              </div>
            </Form.Group>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ThemeEditor;
